import { render, staticRenderFns } from "./AdminPatientsView.vue?vue&type=template&id=0d3e748e&scoped=true"
import script from "./AdminPatientsView.vue?vue&type=script&lang=js"
export * from "./AdminPatientsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3e748e",
  null
  
)

export default component.exports